module.exports = __webpack_public_path__ + "img/fig07.00d1cbf7.jpg";